/**
 * Reads a cookie value by name. Returns `null` when the cookie is absent or when
 * running outside the browser (SSR / non-DOM environments).
 */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null

  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))

  return match ? decodeURIComponent(match[1]) : null
}

/** Options for {@link setCookie} */
export interface SetCookieOptions {
  /**
   * URL path the cookie is scoped to
   * @default '/'
   */
  path?: string
  /**
   * Expiry expressed in days from now (mirrors js-cookie's numeric `expires`)
   */
  expires?: number
}

/**
 * Writes a cookie. No-op outside the browser. `expires` is interpreted as a
 * number of days, matching the semantics of the source app's js-cookie usage.
 */
export function setCookie(name: string, value: string, options: SetCookieOptions = {}): void {
  if (typeof document === 'undefined') return

  const { path = '/', expires } = options
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}`

  if (typeof expires === 'number') {
    const date = new Date()
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000)
    cookie += `; expires=${date.toUTCString()}`
  }

  document.cookie = cookie
}
